import IntroListComponent from './IntroListComponent';

export default IntroListComponent;
